<template>
  <base-section
    id="features"
    title="test"
  >
    <base-section-heading
      title="A l'hivernage de la piscine"
    >
    </base-section-heading>
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <base-info-card
              align="center"
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          icon: 'mdi-help-rhombus',
          title: 'Simplicité',
          align: 'justify',
          text: 'L\'utilisation de Crystalline H20 au moment de l\'hivernage contribuera à simplifier le démarrage de votre piscine au printemps suivant',
        },
        {
          icon: 'mdi-arrow-right',
          title: 'Première étape',
          text: 'Attendez le plus tard possible dans la saison pour hiverner votre piscine. Votre eau deviendra claire plus rapidement au printemps',
        },
        {
          icon: 'mdi-arrow-right',
          title: 'Deuxième étape',
          text: 'Avant de baisser votre niveau d\'eau et de procéder à l\'hivernage, ajoutez ' +
            'une dose habituelle de Crystalline H20 dans votre skimmer.' +
            ' Diluez ensuite une dose supplémentaire dans de l\'eau chaude' +
            ' et dispersez le mélange dans la piscine.',
        },
        {
          icon: 'mdi-decagram-outline',
          title: 'Résultat',
          text: 'Finalement, fermez votre piscine comme d\'habitude. Une eau plus propre au printemps simplifie ' +
            'la mise en marche, vous faisant économiser temps et argent',
        },
      ],
    }),
  }
</script>
